import React, { Component } from 'react';
import { Card, Divider, Table } from 'antd';
import DescriptionList from '@comm/DescriptionList';
import { Link } from 'react-router';
import moment from 'moment';
import { connect } from 'react-redux';
import './expenses.less';
import { queryFilePreview } from '@api/pub/attachment';

const { Description } = DescriptionList;

class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
    };
  }

  componentWillMount() {}

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  columns = () => {
    return [
      {
        title: '名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '附件',
        dataIndex: 'uuid',
        key: 'uuid',
        render: (text, record) => {
          return (
            <div>
              {(record.files || []).map(item => {
                return (
                  <a
                    key={item.uuid}
                    style={{ display: 'block' }}
                    onClick={() => queryFilePreview(item)}
                  >
                    {item.name}
                  </a>
                );
              })}
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { dataItem } = this.state;
    return (
      <Card title="任务结果">
        <DescriptionList size="large" col={3}>
          <Description term="任务名称">
            <Link to={`/task/task_detail/${dataItem.uuid}`}>{dataItem.name}</Link>
          </Description>
          <Description term="任务周期">
            {`${moment.unix(dataItem.beginDate / 1000).format('YYYY-MM-DD')}至${moment
              .unix(dataItem.endDate / 1000)
              .format('YYYY-MM-DD')}`}
          </Description>
          <Description term="所属项目">
            <Link to={`/task/project_detail/${dataItem.projectUuid}`}>{dataItem.projectName}</Link>
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="任务描述">{dataItem.remark}</Description>
        </DescriptionList>

        <Divider />
        <DescriptionList size="large" col={3}>
          {dataItem.aim ? <Description term="任务目标">{dataItem.aim}</Description> : ''}
          {dataItem.aim ? <Description term="实际数据">{dataItem.actual}</Description> : ''}
          <Description term="完成状态">
            {dataItem.completionStatus === 2 ? '已完成' : '未完成'}
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="申请文件">
            <Table
              rowKey="uuid"
              pagination={false}
              columns={this.columns()}
              dataSource={dataItem.attachment}
            />
          </Description>
        </DescriptionList>
        <DescriptionList size="large" col={1}>
          <Description term="申请说明">{dataItem.completionRemark}</Description>
        </DescriptionList>
        {dataItem.completionRemark}
      </Card>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/task/taskCheck/FormOpen.js